import React, { useState, useEffect } from 'react';
import {
  Grid,
  Box,
  TextField,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  IconButton,
  Typography,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Autocomplete,
  CircularProgress
} from "@mui/material";
import {
  //getProfile,
  getProfilesByApplication,
  getApplicationByProfile
} from '../logic';
import { DataGrid } from '@mui/x-data-grid';
import { Spanish } from '../../../../shared/grid-translations';
import Button from '@mui/material/Button';
import Delete from '@mui/icons-material/Delete';
import SaveIcon from '@mui/icons-material/Save';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import CancelIcon from '@mui/icons-material/Cancel';
import { ACTIONS } from '../../../../shared/constants';
import { getUser } from '../../../../shared/auth-service';

const ManagementPositionOptionDetail = ({
  data,
  handleClose,
  handleSave,
  employeePositionId,
  employeePosition,
  profiles,
  applications
}) => {
  const [selectedEmployeePositionId, setSelectedEmployeePosition] = useState(employeePositionId);
  const [selectedCodes, setSelectedCodes] = useState(data || []);
  const [selectedApplicationId, setSelectedApplicationId] = useState('');
  const [selectedCodesSend, setSelectedCodesSend] = useState({
    profiles: [], 
    employeePositionId: selectedEmployeePositionId, 
  });
  const [selectedCode, setSelectedCode] = useState(null);
  const [perfilId, setPerfilId] = useState(data.perfilId);
  const [filteredProfiles, setFilteredProfiles] = useState([]);
  const [loadingProfiles, setLoadingProfiles] = useState(false);
  const userData = getUser();
  const companyId = userData.countryCode.split('-')[0];



const handleAddEmployeePositions = (e) => {
  e.stopPropagation();

  if (!selectedCode || !selectedApplicationId) return;

  const application = applications.find(a => a.id === selectedApplicationId);
  if (!application) return;

  const existingIndex = selectedCodes.findIndex(
    el => el.profileId === selectedCode.id
  );

  let updatedProfiles = [...selectedCodes];

  if (existingIndex !== -1) {
    const existing = updatedProfiles[existingIndex];

    // Solo agrega si la app aún no está
    if (!existing.applicationIds.includes(application.id)) {
      const newAppNames = [...existing.applicationName.split(' / '), application.name];
      const newAppIds = [...existing.applicationIds, application.id];

      updatedProfiles[existingIndex] = {
        ...existing,
        applicationName: Array.from(new Set(newAppNames)).join(' / '),
        applicationIds: Array.from(new Set(newAppIds))
      };
    } else {
      // Ya existe la app en este perfil
      return;
    }
  } else {
    updatedProfiles.push({
      id: `${selectedCode.id}`,
      profileId: selectedCode.id,
      description: selectedCode.description,
      applicationId: application.id,
      applicationName: application.name,
      applicationIds: [application.id]
    });
  }

  setSelectedCodes(updatedProfiles);

  setSelectedCodesSend({
    profiles: updatedProfiles.map(({ profileId, description, applicationIds }) => ({
      Id: profileId,
      Description: description,
      ApplicationIds: applicationIds
    })),
    employeePositionId: selectedEmployeePositionId
  });
};


useEffect(() => {
  const normalizeProfilesWithApplications = async () => {
    if (data?.length > 0) {
      setLoadingProfiles(true); // INICIO

      const profileMap = new Map();

      for (const p of data) {
        const apps = await getApplicationByProfile(p.id);

        if (!apps || apps.length === 0) continue;

        const existing = profileMap.get(p.id);

        const newAppNames = apps.map(a => a.name);
        const newAppIds = apps.map(a => a.id);

        if (existing) {
          existing.applicationName = [...new Set([...existing.applicationName.split(' / '), ...newAppNames])].join(' / ');
          existing.applicationIds = [...new Set([...existing.applicationIds, ...newAppIds])];
        } else {
          profileMap.set(p.id, {
            id: p.id,
            profileId: p.id,
            description: p.description,
            applicationName: newAppNames.join(' / '),
            applicationIds: newAppIds
          });
        }
      }

      const normalized = Array.from(profileMap.values());

      setSelectedCodes(normalized);

      setSelectedCodesSend({
        profiles: normalized.map(({ profileId, description, applicationIds }) => ({
          Id: profileId,
          Description: description,
          ApplicationIds: applicationIds
        })),
        employeePositionId: selectedEmployeePositionId
      });

      setLoadingProfiles(false); // FIN
    }
  };

  normalizeProfilesWithApplications();
}, [applications, data]);



  useEffect(() => {
    const fetchProfiles = async () => {
      if (selectedApplicationId) {
        const filtered = await getProfilesByApplication(selectedApplicationId, companyId);
        setFilteredProfiles(filtered);
        setPerfilId('');
        setSelectedCode(null);
      } else {
        setFilteredProfiles([]);
      }
    };

    fetchProfiles();
  }, [selectedApplicationId]);




 const handleDelete = (e, cellValues) => {
  e.stopPropagation();
  const updatedSelectedCodes = selectedCodes.filter(el => el.id !== cellValues.row.id);
  setSelectedCodes(updatedSelectedCodes);

  setSelectedCodesSend({
    profiles: updatedSelectedCodes.flatMap(({ profileId, description, applicationIds }) =>
      applicationIds.map(appId => ({
        Id: profileId,
        Description: description,
        ApplicationId: appId
      }))
    ),
    employeePositionId: selectedEmployeePositionId
  });
};


  const codeColumns = [
    { field: 'id', headerName: 'Id', flex: 1, hide: true},
    { field: 'description', headerName: 'Descripción', minWidth: 100, flex: 1 },
    {
      field: 'applicationName',
      headerName: 'Aplicación',
      minWidth: 150,
      flex: 1
    },
    {
      field: "EditSources",
      headerName: "Borrar",
      width: 60,
      sortable: false,
      renderCell: (cellValues) => {
        return <IconButton
          color="error"
          onClick={(e) => { handleDelete(e, cellValues) }}
        >
          <Delete />
        </IconButton>;
      }
    },
  ];

  return (
    <Dialog maxWidth="md" fullWidth open>
      <DialogTitle>Detalle Cargo</DialogTitle>
      <DialogContent>
        <TextField
          label="Cargo"
          fullWidth
          defaultValue={employeePosition}
          InputProps={{ readOnly: true }}
          variant="outlined"
        />
        <Typography variant="h6" gutterBottom sx={{ mt: 2 }}>
          Perfiles
        </Typography>

    <Grid container spacing={2}>
        {/* Autocomplete de Aplicación */}
        <Grid item xs={12} sm={6}>
          <FormControl fullWidth margin="dense">
            <Autocomplete
              id="autocomplete-application"
              options={applications}
              getOptionLabel={(option) => option.name || ''}
              isOptionEqualToValue={(option, value) => option.id === value.id}
              value={applications.find(a => a.id === selectedApplicationId) || null}
              onChange={(event, newValue) => {
                setSelectedApplicationId(newValue ? newValue.id : '');
              }}
              renderInput={(params) => (
                <TextField {...params} label="Aplicación" variant="outlined" size="small" />
              )}
              noOptionsText="Sin resultados"
            />
          </FormControl>
        </Grid>

        {/* Autocomplete de Perfil + Botón + */}
        <Grid item xs={12} sm={6}>
          <Grid container spacing={1} alignItems="center">
            <Grid item xs={11}>
              <FormControl fullWidth margin="dense">
                <Autocomplete
                  id="autocomplete-profile"
                  options={selectedApplicationId ? filteredProfiles : []}
                  getOptionLabel={(option) => option?.description || ''}
                  isOptionEqualToValue={(option, value) => option.id === value.id}
                  value={filteredProfiles.find(p => p.id === perfilId) || null}
                  onChange={(event, newValue) => {
                    setPerfilId(newValue ? newValue.id : '');
                    setSelectedCode(newValue || null);
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Perfil"
                      variant="outlined"
                      size="small"
                      disabled={!selectedApplicationId}
                    />
                  )}
                  noOptionsText="Seleccione una aplicación primero"
                />
              </FormControl>
            </Grid>
            <Grid item xs={1}>
              <IconButton
                color="primary"
                disabled={!selectedCode || !selectedApplicationId}
                onClick={(e) => handleAddEmployeePositions(e)}
                sx={{ mt: 0.5 }}
              >
                <AddCircleIcon />
              </IconButton>
            </Grid>
          </Grid>
        </Grid>
      </Grid>


        <Box mt={2}>
  {loadingProfiles ? (
    <Box display="flex" justifyContent="center" alignItems="center" height={300}>
      <CircularProgress />
      <Typography variant="body1" sx={{ ml: 2 }}>Cargando perfiles...</Typography>
    </Box>
  ) : (
    <DataGrid
      style={{ height: 300, width: '100%' }}
      columns={codeColumns}
      getRowId={(row) => `${row.profileId}`}
      rows={selectedCodes}
      localeText={{ ...Spanish }}
      componentsProps={{
        pagination: {
          labelRowsPerPage: 'Filas por página'
        }
      }}
      sx={{
        '& .MuiDataGrid-columnHeaderTitle': {
          fontWeight: 'bold',
        },
      }}
    />
  )}
</Box>

      </DialogContent>

      <DialogActions sx={{ m: 1 }}>
        <Box>
          <Button
            color="primary"
            variant="contained"
            onClick={() => handleSave(selectedCodesSend)}
            endIcon={<SaveIcon />}
          >
            {ACTIONS.SAVE}
          </Button>
        </Box>
        <Box sx={{ m: 1, position: 'relative' }}>
          <Button
            endIcon={<CancelIcon />}
            variant="outlined"
            onClick={() => handleClose(false)}
            autoFocus
          >
            {ACTIONS.CANCEL}
          </Button>
        </Box>
      </DialogActions>
    </Dialog>
  );
};

export default ManagementPositionOptionDetail;
